module.exports = __webpack_public_path__ + "static/media/biking.aeba2b62.svg";